import styled, { keyframes } from 'styled-components'

const VIDEO_PLAYER_WIDTH = 178
const VIDEO_PLAYER_HEIGHT = 337
const BORDER_RADIUS = 16
const PLAY_BUTTON_SIZE = 40
const ICON_SIZE = 16
const OVERLAY_OPACITY = 0.5
const FONT_SIZE = 12

export const Container = styled.div`
  width: ${VIDEO_PLAYER_WIDTH}px;
  height: ${VIDEO_PLAYER_HEIGHT}px;
  border-radius: ${BORDER_RADIUS}px;
  overflow: hidden;
  position: relative;
  box-shadow: ${({ theme }) => theme.shadow.card};
  background-color: ${({ theme }) => theme.color.white};
`

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`

export const Overlay = styled.div`
  position: absolute;
  inset: 0;
  background-color: ${({ theme }) => theme.unchangingColor.black};
  opacity: ${OVERLAY_OPACITY};
  pointer-events: none;
`

export const PlayButton = styled.button`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: ${PLAY_BUTTON_SIZE}px;
  height: ${PLAY_BUTTON_SIZE}px;
  border: none;
  outline: none;
  cursor: pointer;
  background-color: transparent;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  color: ${({ theme }) => theme.unchangingColor.white};
`

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

export const SpinningIconWrapper = styled.div`
  width: ${PLAY_BUTTON_SIZE}px;
  height: ${PLAY_BUTTON_SIZE}px;
  animation: ${spin} 1s linear infinite;

  svg {
    width: 100%;
    height: 100%;
  }
`

export const NotAvailableContainer = styled.div`
  width: ${VIDEO_PLAYER_WIDTH}px;
  height: ${VIDEO_PLAYER_HEIGHT}px;
  border-radius: ${BORDER_RADIUS}px;
  overflow: hidden;
  box-shadow: ${({ theme }) => theme.shadow.card};
  background-color: ${({ theme }) => theme.color.white};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: ${BORDER_RADIUS}px;
`

export const IconWrapper = styled.div`
  width: ${ICON_SIZE}px;
  height: ${ICON_SIZE}px;
  color: ${({ theme }) => theme.color.darkGrey};

  svg {
    width: 100%;
    height: 100%;
  }
`

export const NotAvailableText = styled.div`
  font-size: ${FONT_SIZE}px;
  line-height: 1.5;
  text-align: center;
  color: ${({ theme }) => theme.color.darkGrey};

  p {
    margin: 0;
  }
`
